import { createAction, props } from '@ngrx/store';
import { DrawerParms, DrawerType } from '@care-portals/api-interfaces';

export const openDrawer = createAction(
  '[DrawerState] Open Drawer',
  props<{ params: DrawerParms }>()
);

export const openDrawerSuccess = createAction(
  '[DrawerState] Open Drawer Success',
  props<{ drawerName: DrawerType}>()
);

export const openDrawerFailure = createAction(
  '[DrawerState] Open Drawer Failure',
  props<{ error: any }>()
);

export const closeDrawer = createAction(
  '[DrawerState] Close Drawer',
  props<{ params: DrawerParms }>()
);

export const closeDrawerSuccess = createAction(
  '[DrawerState] Close Drawer Success',
  props<{ popped: DrawerParms; drawers: DrawerType[] }>()
);

export const closeDrawerFailure = createAction(
  '[DrawerState] Close Drawer Failure',
  props<{ error: any }>()
);
